import { Fragment, type PropsWithChildren, type ReactNode } from 'react';

import { Backdrop } from '@shared/atoms/backdrop';

import { Container, Row } from '@playbook/modules/layout';
import { MinMediaQuery } from '@playbook/modules/layout/media-query';
import { cn } from '@playbook/utils';

import css from './styles.module.css';

interface DocumentationLayoutProps extends PropsWithChildren {
	fullWidth?: boolean;
	useBrandBackdrop?: boolean;

	renderSidebarWith?: ReactNode;
}

export function DocumentationLayout({
	fullWidth = false,
	useBrandBackdrop = false,

	renderSidebarWith,

	children,
}: DocumentationLayoutProps): ReactNode {
	return (
		<Fragment>
			<Container name="docs">
				<Row columns={renderSidebarWith ? ['1fr', '1fr', '300px 1fr'] : '1fr'}>
					{renderSidebarWith && (
						<MinMediaQuery breakpoint="959px">
							<aside className={cn(css.wrapper, css.sidebar)}>
								{renderSidebarWith}
							</aside>
						</MinMediaQuery>
					)}
					<main
						className={cn(
							css.wrapper,
							css.main,
							fullWidth && css.fullWidth,
							useBrandBackdrop && css.brandBackdrop
						)}>
						{children}
					</main>
				</Row>
			</Container>
			{!useBrandBackdrop && <Backdrop opacity={0.5} />}
		</Fragment>
	);
}
